import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMasterDataApi } from "./masterApi";
import { getStorage, setStorage, STORAGE, STORAGE_TTL } from "../../utils/storageHelper";

export const getMasterData = createAsyncThunk(
    "master/getMasterData",
    async (_, thunkAPI) => {
        try {
            const cached = getStorage(STORAGE.MASTER_DATA, STORAGE_TTL.MASTER_DATA);

            if (cached) {
                return cached;
            }

            const res = await getMasterDataApi();
            const data = res.data.data;
            setStorage(STORAGE.MASTER_DATA, data);

            return data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Something went wrong"
            );
        }
    }
);

const masterSlice = createSlice({
    name: "master",
    initialState: {
        masterData: null,
        loading: false,
        error: null,
    },
    reducers: {},

    extraReducers: (builder) => {
        builder

            .addCase(getMasterData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(getMasterData.fulfilled, (state, action) => {
                state.loading = false;
                state.masterData = action.payload;
            })

            .addCase(getMasterData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Something went wrong";
            });
    },
});

export default masterSlice.reducer;